// src/components/Servicios.jsx

const servicios = [
  {
    id: 1,
    nombre: "PPF",
    imagen: "/imagenes/ppf.webp",
    mensaje: "Hola, quisiera consultar sobre el servicio de PPF.",
  },
  {
    id: 5,
    nombre: "Láminas de seguridad y control solar",
    imagen: "/imagenes/lamina_control_solar.webp",
    mensaje: "Hola, quisiera consultar sobre el servicio de Láminas de seguridad y Control solar.",
  },
  {
    id: 2,
    nombre: "Tratamiento Ceramico",
    imagen: "/imagenes/1.webp",
    mensaje: "Hola, quisiera consultar sobre el servicio de Tratamiento Ceramico.",
  },
  {
    id: 3,
    nombre: "Wraping",
    imagen: "/imagenes/wrapping.webp",
    mensaje: "Hola, quisiera consultar sobre el Wraping.",
  },
  {
    id: 4,
    nombre: "Preparación de Venta",
    imagen: "/imagenes/4.webp",
    mensaje: "Hola, quisiera consultar sobre el servicio Preparación de Venta.",
  },
  {
    id: 6,
    nombre: "Cursos",
    imagen: "/imagenes/curso.webp",
    mensaje: "Hola, quisiera consultar sobre Cursos.",
  },
];

export default function Servicios() {
  return (
    <section className="servicios">
      <h1>Lideres en protección vehicular y profesionales en PPF</h1>
      <hr className="divisor-servicios" />
      <h2>SERVICIOS</h2>

      <div className="grid-servicios">
        {servicios.map((servicio) => (
          <div
            key={servicio.id}
            className={`card-servicio ${
              [1, 5].includes(servicio.id) ? "card-servicio--alta" : ""
            }`}
          >
            <img
              src={servicio.imagen}
              alt={servicio.nombre}
              className="imagen-servicio"
            />
            <h3>{servicio.nombre}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}

